import { License } from '@/store/commonStore/types';

export const DEFAULT_LICENSE = License.TB;

export const CONTENT_BY_LICENSE_POPULATE = { content_by_license: true };
